import { ContentBlock } from "@/components/ContentBlock/ContentBlock";
import DefinitionList from "@/components/DefinitionList/DefinitionList";
import { useHtmlifiedTranslations } from "@/services/useHtmlifiedTranslations";
import { htmlify } from "@/services/utils";
import type { FundDetailLayoutComponentProps } from "@/types/fundDetailLayout";

export const FxAwardsPanel = ({ dashboard, scrollToComponent }: FundDetailLayoutComponentProps) => {
	const { translations: encodedTranslations } = dashboard;
	const translations = useHtmlifiedTranslations(encodedTranslations);
	const props = dashboard.fxAwardsPanel;

	if (!props) {
		return null;
	}

	const { heading, ...remainingProps } = props;

	return (
		<ContentBlock id="FxAwardsPanel" data-testid="FxAwardsPanel" heading={htmlify(heading)}>
			<DefinitionList scrollToComponent={scrollToComponent} {...remainingProps} translations={translations} />
		</ContentBlock>
	);
};
